import PropTypes from "prop-types";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { useForm } from "react-hook-form";

export const FormContext = createContext(null);

export const FormsProvider = ({ children }) => {
  const [isEnable, setIsEnable] = useState(false);
  const methods = useForm({
    mode: "all",
    reValidateMode: "all",
    defaultValues: {},
  });

  const {
    reset,
    handleSubmit,
    control,
    watch,
    getValues,
    formState,
    setValue,
  } = methods;

  const memoizedValue = useMemo(
    () => ({
      reset,
      handleSubmit,
      control,
      watch,
      getValues,
      formState,
      setValue,
      isEnable,
      setIsEnable,
    }),
    [
      reset,
      handleSubmit,
      control,
      watch,
      getValues,
      formState,
      setValue,
      isEnable,
      setIsEnable,
    ]
  );

  return (
    <FormContext.Provider value={memoizedValue}>
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => {
  const context = useContext(FormContext);

  if (!context)
    throw new Error("useFormContext context must be use inside FormsProvider");

  return context;
};

FormsProvider.propType = {
  children: PropTypes.node,
};

// ----------------------------------------------------------------------
